import { STORES_REQUEST_START, STORES_REQUEST_FAIL, STORES_REQUEST_SUCCESS, STORES_SELECT_COUNTRY, COUNTRY_REQUEST_START, COUNTRY_REQUEST_ERROR, COUNTRY_REQUEST_SUCCESS } from "../actions/stores";

const stateDefault = {
    isFetchingCountries: false,
    countries: [],
    hasErrorCountries: false,
    selectedCountry: null,

    isFetching: false,
    hasError: false,
    stores: {},
}

export const storesReducer = (state = stateDefault, action) => {
    switch (action.type) {
        case COUNTRY_REQUEST_START: return { ...state, isFetchingCountries: true, hasErrorCountries: false, countries: [] }
        case COUNTRY_REQUEST_ERROR: return { ...state, isFetchingCountries: false, hasErrorCountries: true, countries: [] }
        case COUNTRY_REQUEST_SUCCESS: return { ...state, isFetchingCountries: false, hasErrorCountries: false , countries: action.countries }
        case STORES_SELECT_COUNTRY: {
            return { ...state, selectedCountry: action.country }
        }

        case STORES_REQUEST_START: {
            return { ...state, isFetching: true, hasError: false }
        }
        case STORES_REQUEST_FAIL: {
            return { ...state, isFetching: false, hasError: true }
        }
        case STORES_REQUEST_SUCCESS: {
            return { ...state, isFetching: false, hasError: false, stores: { ...state.stores, [action.countryId]: action.stores } }
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/stores.js